import { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import { analytics } from 'core/analytics/analytics'
import ShipperGuideLayout from 'core/ui/components/shipperguide-layout/ShipperGuideLayout'
import { useDisableSalesforceChat } from 'core/ui/hooks/useDisableSalesforceChat'
import { PageNotFound } from 'core/ui/router/PageNotFound'

import { useSaveMagicLinkToken } from 'auth/ui/hooks/useSaveMagicLinkToken'
import { useConfigContext } from 'config/ui/ConfigContext'

import BidsPanel from '../bids/ui/BidsPanel'
import { PORTAL_BASE_PATH } from '../core/domain/PortalRoute'
import RfpPage from '../rfp/ui/RfpPage'
import { ShipmentDetails } from '../shipments/ui/ShipmentDetails'
import { ShippersPage } from '../shippers/ui/ShippersPage'
import SpotQuotePage from '../spot-quotes/ui/SpotQuotePage'
import { TenderPage } from '../tender/ui/TenderPage'

const BASE_PATH = PORTAL_BASE_PATH

export default function ShipperGuide() {
  useDisableSalesforceChat()
  useSaveMagicLinkToken()

  const { enableShipperListPage } = useConfigContext()

  useEffect(() => {
    analytics.init()
  }, [])

  return (
    <ShipperGuideLayout>
      <Switch>
        <Route path={`${BASE_PATH}/shipment/:shipmentUUID/:section?`}>
          <ShipmentDetails />
        </Route>
        <Route path={`${BASE_PATH}/bids-list`} exact>
          <BidsPanel />
        </Route>
        <Route path={`${BASE_PATH}/bids/spot-quote`} component={SpotQuotePage} />
        <Route path={`${BASE_PATH}/tender/:id`} component={TenderPage} />
        <Route path={`${BASE_PATH}/rfp`} component={RfpPage} />
        {enableShipperListPage.toBoolean() && (
          <Route path={`${BASE_PATH}/shippers`} component={ShippersPage} />
        )}
        <Route path="*">
          <PageNotFound />
        </Route>
      </Switch>
    </ShipperGuideLayout>
  )
}
